import { createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    subscriptionRequest: ['subscriptionId'],
    subscriptionAllRequest: ['options'],
    subscriptionSearchRequest: ['filters', 'options'],
    subscriptionDateSearchRequest: ['query', 'businessId', 'startDate', 'endDate', 'options'],
    subscriptionSearchCountRequest: ['query', 'filters'],
    subscriptionCountRequest: ['options'],
    pauseSubscriptionRequest: ['subscriptionId'],
    cancelSubscriptionRequest: ['subscriptionId'],
    rescheduleSubscriptionRequest: ['subscriptionId', 'date'],
    subscriptionSearchAllRequest: ['businessId', 'params'],
    subscriptionSearchAllCountRequest: ['businessId', 'params'],
    subscriptionSearchAllClear: [],
    subscriptionSearchAllCountClear: [],

    subscriptionSuccess: ['subscription'],
    subscriptionAllSuccess: ['subscriptions'],
    subscriptionSearchSuccess: ['searchSubscriptions'],
    subscriptionDateSearchSuccess: ['dateSearchSubscriptions'],
    subscriptionSearchCountSuccess: ['count'],
    subscriptionCountSuccess: ['count'],
    pauseSubscriptionSuccess: ['data'],
    cancelSubscriptionSuccess: [],
    rescheduleSubscriptionSuccess: ['data'],
    subscriptionSearchAllSuccess: ['subscriptionSearch'],
    subscriptionSearchAllCountSuccess: ['subscriptionSearchAllCount'],
    subscriptionSearchAllCleared: [],
    subscriptionSearchAllCountCleared: [],

    subscriptionFailure: ['error'],
    subscriptionAllFailure: ['error'],
    subscriptionSearchFailure: ['error'],
    subscriptionDateSearchFailure: ['error'],
    subscriptionSearchCountFailure: ['error'],
    subscriptionCountFailure: ['error'],
    pauseSubscriptionFailure: [' error'],
    cancelSubscriptionFailure: [' error'],
    rescheduleSubscriptionFailure: [' error'],
    subscriptionSearchAllFailure: ['error'],
    subscriptionSearchAllCountFailure: ['error'],
})

export const SubscriptionTypes = Types
export default Creators
